import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { EqualMark } from "@/components/brand";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function VerifyMagicLink() {
  const [searchParams] = useSearchParams();
  const [verifying, setVerifying] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get("token");
    
    if (!token) {
      toast.error("Invalid magic link");
      navigate("/");
      return;
    }

    const verifyToken = async () => {
      try {
        const response = await axios.post(`${API}/auth/verify-magic-link`, { token });
        const { token: jwtToken, email, role } = response.data;
        
        localStorage.setItem("token", jwtToken);
        localStorage.setItem("email", email);
        localStorage.setItem("role", role);
        
        toast.success("Login successful!");
        navigate("/chat");
      } catch (error) {
        toast.error(error.response?.data?.detail || "Invalid or expired magic link");
        navigate("/");
      } finally {
        setVerifying(false);
      }
    };

    verifyToken();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-page">
      <div className="card-flat px-10 py-10 flex flex-col items-center text-center animate-rise-in">
        <EqualMark size={36} />
        <div className="mt-6 w-8 h-8 border-2 border-line border-t-equal rounded-full animate-spin" />
        <p className="mt-4 text-sm text-ink font-medium">Verifying your login...</p>
      </div>
    </div>
  );
}
